module.exports = __webpack_public_path__ + "static/img/dealer-coperto.19df7fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards/dealer-coperto.svg
// module id = eTcp
// module chunks = 1